import React from 'react';
import ReactDOM from 'react-dom/client';
import './sentry'; // initialise Sentry before any other module imports
import { Sentry } from './sentry';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const FallbackBoundary = process.env.REACT_APP_SENTRY_DSN
  ? Sentry.ErrorBoundary
  : (React.Fragment as any);

const fallbackProps = process.env.REACT_APP_SENTRY_DSN
  ? {
      fallback: (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#000',
            color: '#fff',
            fontFamily: 'system-ui, sans-serif',
            padding: 24,
            textAlign: 'center',
          }}
        >
          <div>
            <p style={{ fontSize: 12, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#F4C430', marginBottom: 16 }}>
              / hata
            </p>
            <p style={{ fontSize: 18, marginBottom: 8 }}>Beklenmedik bir şey oldu.</p>
            <p style={{ fontSize: 14, opacity: 0.6, marginBottom: 24 }}>
              Sayfayı yenilemeyi dene; sorun sürerse iletişime geç.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 18px',
                background: '#F4C430',
                color: '#000',
                border: 0,
                fontFamily: 'monospace',
                fontSize: 11,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                cursor: 'pointer',
              }}
            >
              Yenile
            </button>
          </div>
        </div>
      ),
    }
  : {};

root.render(
  <React.StrictMode>
    <FallbackBoundary {...fallbackProps}>
      <App />
    </FallbackBoundary>
  </React.StrictMode>
);

